import { addDays, endOfMonth, isAfter } from "date-fns";

/**
 * Проверяет, разрешена ли операция списания
 *
 * Операция списания разрешена, если: today ≤ firstDayNextMonth(finishDate) + writeOffPeriodCutoffDay
 *
 * @param finishDate - Дата завершения АР
 * @param writeOffPeriodCutoffDay - отсечка периода списания
 * @param today - Текущая дата
 * @returns true, если редактирование разрешено, false - если запрещено
 */
export function isWriteOffAllowedForFinishDate(
  finishDate: Date,
  writeOffPeriodCutoffDay: number,
  today: Date = new Date()
): boolean {
  const lastDayOfMonth = endOfMonth(finishDate);
  const cutoffDate = addDays(lastDayOfMonth, writeOffPeriodCutoffDay);

  // Операция списания разрешена, если: today ≤ firstDayNextMonth(finishDate) + writeOffPeriodCutoffDay
  return !isAfter(today, cutoffDate);
}

/** Текст окна ошибки при попытке списания в закрытом периоде  */
export function getAssetsWriteOffClosedPeriodMessage(deadlineDay: number): string {
  return `Списание ТМЦ разрешается не позднее ${deadlineDay} дней с завершения месяца работы.\nДля проведения операции списания обратитесь в службу поддержки.`;
}
